const FREEBIE_WIDGET_PREFIX = "freebie-widget";

export const FREEBIE_WIDGET_TEST_IDS = {
    // Main widget container
    CONTAINER: `${FREEBIE_WIDGET_PREFIX}-container`,

    // Widget states
    LOCKED_STATE: `${FREEBIE_WIDGET_PREFIX}-locked`,
    UNLOCKED_STATE: `${FREEBIE_WIDGET_PREFIX}-unlocked`,

    // Text elements
    TITLE: `${FREEBIE_WIDGET_PREFIX}-title`,
    SUBTITLE: `${FREEBIE_WIDGET_PREFIX}-subtitle`,

    // Item details
    ITEM_IMAGE: `${FREEBIE_WIDGET_PREFIX}-item-image`,
    ITEM_NAME: `${FREEBIE_WIDGET_PREFIX}-item-name`,
    ITEM_ORIGINAL_PRICE: `${FREEBIE_WIDGET_PREFIX}-item-original-price`,
    ITEM_FREE_TEXT: `${FREEBIE_WIDGET_PREFIX}-item-free-text`,
    FOOD_SYMBOL: `${FREEBIE_WIDGET_PREFIX}-food-symbol`,

    // Claim button
    CLAIM_BUTTON: `${FREEBIE_WIDGET_PREFIX}-claim-button`,
    CLAIM_BUTTON_TEXT: `${FREEBIE_WIDGET_PREFIX}-claim-button-text`,
    CLAIM_BUTTON_DISABLED: `${FREEBIE_WIDGET_PREFIX}-claim-button-disabled`,

    // Lottie animation
    LOTTIE_ANIMATION: `${FREEBIE_WIDGET_PREFIX}-lottie`,

    // Success popup
    SUCCESS_POPUP: `${FREEBIE_WIDGET_PREFIX}-success-popup`,
    SUCCESS_POPUP_TITLE: `${FREEBIE_WIDGET_PREFIX}-success-popup-title`,
    SUCCESS_POPUP_MESSAGE: `${FREEBIE_WIDGET_PREFIX}-success-popup-message`,
    SUCCESS_POPUP_CTA: `${FREEBIE_WIDGET_PREFIX}-success-popup-cta`,
    SUCCESS_POPUP_CLOSE: `${FREEBIE_WIDGET_PREFIX}-success-popup-close`,
};

export const FREEBIE_POPUP_TEST_IDS = {
    MODAL: "freebie-popup-modal",
    TITLE: "freebie-popup-title",
    MESSAGE: "freebie-popup-message",
    CTA_BUTTON: "freebie-popup-cta",
    CLOSE_BUTTON: "freebie-popup-close",
};
